var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 152",
    cx: 8.00049,
    cy: 3.50001,
    rx: 3.5,
    ry: 3.50001,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 477",
    d: "M0 12C0 9.79086 1.79086 8 4 8H12C14.2091 8 16 9.79086 16 12V16H0V12Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.73bf32e6c404a2729fb4b5bba3ec0e19.svg";
export { ForwardRef as ReactComponent };